import { render, staticRenderFns } from "./FootageView.vue?vue&type=template&id=6b0597d2&scoped=true"
import script from "./FootageView.vue?vue&type=script&lang=js"
export * from "./FootageView.vue?vue&type=script&lang=js"
import style0 from "./FootageView.vue?vue&type=style&index=0&id=6b0597d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0597d2",
  null
  
)

export default component.exports